import { render, staticRenderFns } from "./black.vue?vue&type=template&id=fc676644&scoped=true"
import script from "./black.vue?vue&type=script&lang=js"
export * from "./black.vue?vue&type=script&lang=js"
import style0 from "./black.vue?vue&type=style&index=0&id=fc676644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc676644",
  null
  
)

export default component.exports